// import { defaultPhone } from "."

export const setCaretPosition = (target: any) => {
  const { value } = target;
  const caretPosition = value.indexOf("_");
  target.setSelectionRange(caretPosition, caretPosition);
}